import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tournament-rules',
  templateUrl: './tournament-rules.component.html',
  styleUrls: ['./tournament-rules.component.css']
})
export class TournamentRulesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
